import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const LearningQuestions = ({
  questionNumber,
  categories,
  totalQuestions
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[3].icon}
          categoryName={categories[3].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="过去一学期/或者最近一个月，有什么主题/内容，会让你自发地学习探索 ，愿意主动查资料，或者平时浏览网页时主动点击进去了解？" 
          value={formData.interestingTopics}
          onChange={(value) => handleInputChange('interestingTopics', value)}
          inputType="textarea"
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[3].icon}
          categoryName={categories[3].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="回想一下最近一次你完全投入在某件事中以至于忘记了时间的经历。那时候在做什么？通常什么类型的事情会让你这样投入?" 
          value={formData.flowExperience}
          onChange={(value) => handleInputChange('flowExperience', value)}
          inputType="textarea"
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[3].icon}
          categoryName={categories[3].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="你更喜欢&quot;如何改善这个产品&quot;（开放式）还是&quot;计算这个公司的估值&quot;（结构化）类型的作业? 为什么这个选择对你更有吸引力?" 
          value={formData.assignmentPreference}
          onChange={(value) => handleInputChange('assignmentPreference', value)}
          inputType="textarea"
        />
      );
    default:
      return null;
  }
};

export default LearningQuestions;
